// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
import Vue2TouchEvents from 'vue2-touch-events';
import store from './store';
import locales from './locales/locales.json';
import Notifications from 'vue-notification';
import axios from './tools/axios-instance.js';
import httpInterceptor from './tools/httpInterceptor.js';
import VueEditor from 'vue2-editor';
import * as Sentry from './tools/sentry';
// import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import VueTopprogress from 'vue-top-progress';

Vue.use(VueTopprogress);
Vue.use(VueFormWizard);
// Vue.use(VueTabs)
Vue.use(VueI18n);
Vue.use(Vue2TouchEvents);
Vue.use(Notifications);
Vue.use(VueEditor);

Vue.config.productionTip = false;
Vue.config.debug = (process.env.NODE_ENV === 'development'); // #TODO a vérifier car ne semble pas fonctionner
axios.defaults.withCredentials = true;
Vue.prototype.$http = axios; // #TODO à supprimer une fois le refactoring des call API effectué ==> Si plus de call API depuis les fichiers .vue cela devient inutile
httpInterceptor();

// Détermination de la langue de l'utilisateur
var language = navigator.language || navigator.userLanguage;

// gestion de l'internationalisation
const i18n = new VueI18n({
  locale: getAppLanguage(language),
  fallbackLocale: 'fr',
  messages: locales
});

// Fonction globale qui permet de définir le langage de l'application
Vue.prototype.$setI18nLanguage = function (lang) {
  i18n.locale = lang;
  return lang;
};

Vue.prototype.$setNewAppColor = function (color) {
  var style = document.getElementById('customColor');
  style.innerText = '' +
    '.bg-color{' +
      'background-color: ' + color + ' !important;' +
      'border-color: ' + color + ' !important;' +
    '}' +
    '.form-control:focus{' +
    '  border: 1px solid ' + color +
    '  box-shadow: unset;' +
    '}' +
    'input:checked + .slider {' +
    '  background-color: ' + color +
    '}';
  if (this.$isMobile()) {
    style.innerText += 'button:active {' +
      '  background-color: ' + color + ' !important;' +
      '}';
  } else {
    style.innerText += 'button:hover {' +
      '  background-color: ' + color + ' !important;' +
      '}';
  }
};

Vue.prototype.$formatDateToISO = function (date) {
  let d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};

function getAppLanguage (lang) {
  if (lang !== undefined) {
    return lang.split('-')[0];
  }
}

Vue.prototype.$isMobile = function () {
  var check = false;
  /* eslint-disable no-useless-escape */
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
});

// INITIALISATION DE SENTRY
Sentry.sentryInit();
Vue.prototype.$sentry = Sentry;



// WEBPACK FOOTER //
// ./src/main.js